import { render, staticRenderFns } from "./addtow.vue?vue&type=template&id=307d9306&scoped=true"
import script from "./addtow.vue?vue&type=script&lang=js"
export * from "./addtow.vue?vue&type=script&lang=js"
import style0 from "./addtow.vue?vue&type=style&index=0&id=307d9306&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307d9306",
  null
  
)

export default component.exports